import { db } from "config/firebase";
import { User } from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";

interface AddUserParams {
  user: User;
  city: string;
  state: string;
}

export const addUserAndDocsToDB = async ({
  user,
  city,
  state,
}: AddUserParams): Promise<void> => {
  const today = new Date();
  const joinD = `${today.getMonth() + 1}/${today.getDate()}/${today.getFullYear()}`;

  try {
    // Set main user document
    await setDoc(doc(db, "users", user.uid), {
      id: user.uid,
      displayName: user.displayName,
      city,
      state,
      profileBio: "Hi! I'm new to LocalCards! Let's play a game!",
      joinDate: joinD,
    });

    // Set user metadata
    await setDoc(doc(db, "users", user.uid, "data", "metadata"), {
      id: user.uid,
      email: user.email,
      phoneNumber: "",
      emailNotifications: {
        newMessage: true,
        requestAccepted: false,
        requestDeclined: false,
        confirmationNeeded: true,
        confirmationAccepted: true,
        confirmationDeclined: false,
      },
      textNotifications: {
        newMessage: false,
        requestAccepted: false,
        requestDeclined: false,
        confirmationNeeded: false,
        confirmationAccepted: false,
        confirmationDeclined: false,
      },
    });

    // Set user messages data
    await setDoc(doc(db, "users", user.uid, "data", "messages"), {
      numMsgs: 0,
      unreadMsgs: 0,
    });
  } catch (err) {
    throw new Error(err as string);
  }
};

interface SaveNoteParams {
  userId: string;
  itemId: string;
  itemName: string;
  content: string;
}

export const saveNote = async ({
  userId,
  itemId,
  itemName,
  content,
}: SaveNoteParams): Promise<{ success: string }> => {
  try {
    await setDoc(doc(db, "users", userId, "notes", itemId), {
      id: itemId,
      itemName,
      content,
      edittedOn: Date.now(),
    });
    return { success: "Note updated successfully" };
  } catch (err) {
    throw new Error(`Error Adding Note: ${err}`);
  }
};

interface GetNoteParams {
  userId: string;
  itemId: string;
}

export const getNote = async ({
  userId,
  itemId,
}: GetNoteParams): Promise<any> => {
  const docRef = doc(db, "users", userId, "notes", itemId);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data();
  }
  return undefined;
};

export default {
  addUserAndDocsToDB,
  saveNote,
  getNote,
};
